import React from 'react';
import { getI18NMessage } from 'I18N/I18NHelper';
import { setHeaderHeight, changeHomePage, openCardTypeSettings, openOutlookSettings } from 'js/app/actions/AppActions';
import { GLOBAL_CONSTANTS } from 'js/common/constants/GlobalConstants';
import { updateIssueCollectorConfig } from 'js/modules/issue/actions/IssueConfigActions';
import AppHelper from 'js/app/AppHelper';
import { showMessage } from 'js/modules/message/actions/MessageActions';
import { BOARD_MESSAGE_CONSTANT } from 'js/modules/message/constants/MessageConstants';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FeatureFlag from 'js/toggle/FeatureFlag';
import AppUtil from 'js/utils/AppUtil';

class AppHeaderView extends React.Component {
	constructor(props) {
		super(props);

        this.state = {};

        this.onMenuClose = this.onMenuClose.bind(this);
    }
    
    componentDidMount() {
        const that = this;

        this.props.initAppHeader();

        setTimeout( () => {
            const height = typeof document !== 'undefined' && document.getElementById('header') ? document.getElementById('header').offsetHeight : 0;
            that.props.store.dispatch( setHeaderHeight(height) );
        }, 0)
    }

	render() {
        if ( !this.props.headerData || !this.props.headerData.loaded ) {
            return false;
        }


        const w_hasMultiplePlugins = true;

		return (
			<div className='header full_width' id='header'>
                <span className='header_label bold'>{ getI18NMessage( 'appLabel' ) }</span>
                <ul className='float_right btn_panel list_style_none'>
                    <li className='float_left'>
                        <Button variant="contained" color="primary" size="small"
                            startIcon={ <span className="icon-add-icon colored_icn"></span> }
                            onClick={ this.addIssueCollector.bind(this) }
                        >
                            { getI18NMessage("ADD_ISSUE_COLLECTOR") }
                        </Button>
                    </li>
                    <li className='float_left cur_pointer' onClick={w_hasMultiplePlugins ? this.openPluginList.bind(this) : this.clickOnPluginButton.bind(this, "outlook_windows")}>
                        <img className='icon-outlook colored_icn' alt="outlook" src={ AppUtil.processURLForAppContextPath('svg/outlook-icon.svg') }></img>
                        <span className='btn_text'>{ getI18NMessage( 'outlookPlugin' ) }</span>
                    </li>
                    <li className='float_left cur_pointer' onClick={ this.openCardTypeConfigPanel.bind(this)}>
                        <span className='icon-settings-filled icon'></span>
                        <span className='btn_text'>{ getI18NMessage( 'setting' ) }</span>
                    </li>
                </ul>
                {
                    <Menu elevation={0} anchorEl={ this.props.headerData.outlookMenuAnchor } keepMounted
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}
                        open={ Boolean(this.props.headerData.outlookMenuAnchor) }
                        onClose={ this.onMenuClose }
                    >
                        <FeatureFlag name="outlookWebAddin">
                            <MenuItem onClick={ this.clickOnPluginButton.bind(this, "outlook_web") }>
                                { getI18NMessage( 'outlook_web_addin' ) }
                            </MenuItem>
                        </FeatureFlag>
                        <MenuItem onClick={ this.clickOnPluginButton.bind(this, "outlook_windows") }>
                            { getI18NMessage( 'outlook_windows_addin' ) }
                        </MenuItem>
                    </Menu>
                    }
                <div className='ic_desc full_width'>
                    {/* { getI18NMessage( 'IC_DESC1' ) }
                    { getI18NMessage( 'IC_DESC2' ) } */}
                </div> 
            </div>
		);
    }

    /* istanbul ignore next */
    onMenuClose() {
        this.props.hideOutlookMenu();
    }
    
    /* istanbul ignore next */
    addIssueCollector() {
        let cardTypes = AppHelper.getAppData( 'card_type_list' ) || [];
        cardTypes = cardTypes.filter( cardType => cardType.isSelected )

        if ( cardTypes.length > 0 ) {
            this.props.store.dispatch( updateIssueCollectorConfig({
                position: 'right',
                triggerfontcolor: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1
                },
                triggerbgcolor: {
                    r: 255,
                    g: 153,
                    b: 102,
                    a: 1
                }
            }) );
            this.props.store.dispatch( changeHomePage(GLOBAL_CONSTANTS.ADD_ISSUE_COLLECTOR) );
        } else {
            this.props.store.dispatch( showMessage({
                type: BOARD_MESSAGE_CONSTANT.TYPE_ERROR,
                message: getI18NMessage( 'noCardTypeForIC' )
            }) );
        }
    }

    /* istanbul ignore next */
    openCardTypeConfigPanel() {
        this.props.store.dispatch( openCardTypeSettings());
    }
    
    /* istanbul ignore next */
    openPluginList(event) {
        this.props.showOutlookMenu(event.currentTarget);
    }

    /* istanbul ignore next */
    clickOnPluginButton(plugin) {
        this.onMenuClose();
        this.props.store.dispatch( openOutlookSettings(plugin));
    }
}

export default AppHeaderView;